import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs } from "../mock";

const FAQ = () => {
  return (
    <section id="faq" className="bg-black py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-[#E11D26]" />
            <span className="text-[#E11D26] text-xs sm:text-sm font-bold tracking-[0.25em] uppercase">
              Common Questions
            </span>
            <span className="h-[2px] w-10 bg-[#E11D26]" />
          </div>
          <h2
            className="text-white text-4xl sm:text-5xl md:text-6xl font-black uppercase leading-[0.95]"
            style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
          >
            Frequently Asked <span className="text-[#E11D26]">Questions</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/10 bg-[#0F0F0F] data-[state=open]:border-[#E11D26]/50 px-5 rounded-none"
            >
              <AccordionTrigger className="text-left hover:no-underline py-5">
                <div className="flex items-start gap-5">
                  <span
                    className="text-[#E11D26] text-3xl font-black leading-none shrink-0"
                    style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
                  >
                    Q
                  </span>
                  <span
                    className="text-white text-base sm:text-lg font-black uppercase tracking-wide pt-1"
                    style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
                  >
                    {f.question}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed pl-12 pb-5">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
